import Sidebar from './Sidebar';

// export types
export type { SidebarProps } from './Sidebar';

// export components
export { Sidebar };
export default Sidebar;
